export default '2.5.2';



// WEBPACK FOOTER //
// ./src/lib/version.js